import _ from 'lodash';

export const convertAmount = (amount: number = 0) => {
	return amount / 100;
};
export const convertToCent = (amount = 0) => {
	return _.ceil(amount * 100, 2);
};
